// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__272Rx","topBottomGutter":"Layout_topBottomGutter__2dxgL"};